import React from 'react';
import TimelineItem, { TimelineItemProps } from 'components/TimelineItem';
import { LogDescription } from 'ethers/lib/utils';
import useTranslate from 'hooks/useTranslate';
import { Text } from '@chakra-ui/react';
import { formatEtherBalance } from 'utils/numberUtils';

export interface HoneyReleasedEventTimelineItemProps
  extends Omit<TimelineItemProps, 'title'> {
  type: 'jar' | 'bear';
  log: LogDescription;
}

const HoneyReleasedEventTimelineItem: React.FC<
  HoneyReleasedEventTimelineItemProps
> = ({ type, log, ...rest }) => {
  const translate = useTranslate();
  const translationKeyPrefix = `timeline:events:${type}:released`;

  return (
    <TimelineItem title={translate(`${translationKeyPrefix}:title`)} {...rest}>
      <Text
        dangerouslySetInnerHTML={{
          __html: translate(`${translationKeyPrefix}:description`, {
            id: log.args._tokenId,
            amount: formatEtherBalance(log.args._releasable),
          }),
        }}
      />
    </TimelineItem>
  );
};

export default HoneyReleasedEventTimelineItem;
